import React from "react";

import {
  Card,
  CardBody,
  Gallery,
  GalleryItem,
  Skeleton
} from "@patternfly/react-core";

import { useNewsData } from "../hooks/useNewsData";
import NewsPanel from "./NewsPanel";

const NewsCardSkeleton = () => (
  <Card isFullHeight>
    <Skeleton
      height="220px"
      width="100%"
    />

    <CardBody>
      <br />
      <Skeleton width="25%" />
      <br />

      <Skeleton width="90%" />
      <br />

      <Skeleton width="100%" />
      <br />

      <Skeleton width="85%" />
      <br />

      <Skeleton width="40%" />
    </CardBody>
  </Card>
);

const News = ( {isCard = false} ) => {
  const {
    news,
    loading,
    error
  } = useNewsData();

  if (loading) {
    return (
      <Gallery
        hasGutter
        minWidths={{
          default: "350px"
        }}
      >
        {[1, 2, 3, 4].map((item) => (
          <GalleryItem key={item}>
            <NewsCardSkeleton />
          </GalleryItem>
        ))}
      </Gallery>
    );
  }

  if (
    error ||
    !Array.isArray(news) ||
    news.length === 0
  ) {
    return null;
  }

  return (
    <NewsPanel
      news={news}
      isCard={isCard}
      showHeader
      showAction
      title="Aktualności"
      description="Informacje, wydarzenia, sukcesy uczniów i relacje z życia szkoły."
      actionLabel="Wszystkie aktualności"
      actionHref="/news"
    />
  );
};

export default News;